import { render, staticRenderFns } from "./InquiryCategoryIndex.vue?vue&type=template&id=684a27d3&scoped=true"
import script from "./InquiryCategoryIndex.vue?vue&type=script&lang=js"
export * from "./InquiryCategoryIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684a27d3",
  null
  
)

export default component.exports